import React from "react";

import { CellContext } from "@tanstack/react-table";

import { CarePlan } from "@/models/CarePlanModel.ts";
import { FileModel } from "@/models/FileModel.ts";
import { FileView } from "@/uiKit/molecules/FileView.tsx";

export type PrescriptionColumnProps = CellContext<CarePlan, FileModel | undefined>;

export const PrescriptionColumn: React.FC<PrescriptionColumnProps> = ({ getValue, row: { original } }) => {
  const value = getValue();

  return value && <FileView id={`care-plan-history-prescription-${original.id}`} file={value} />;
};
